import React from 'react';
import { ContactType } from 'models';
import { RadioInput } from 'components/atom/form/radiofield';

type ContactTypeRadioProps = {
  name: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  onChange?: (value: ContactType) => void;
};

export function ContactTypeRadio(props: ContactTypeRadioProps) {
  const options = [
    {
      value: ContactType.Client,
      display: 'Client',
    },
    {
      value: ContactType.Organisation,
      display: 'Organization',
    },
  ];
  return <RadioInput options={options} optionsDirection="horizontal" {...props} />;
}
